{
  "version": "0.0.0",
  "id": "at.softline.lagerhaus.thermenland.softline",
  "name": "Softline Thermenland"
}
